export enum GateActionTypeEnum {
    Checkin = 'Checkin',
    CheckinRepresentative = 'CheckinRepresentative',
    Checkout = 'Checkout'
}
